module.exports = __webpack_public_path__ + "img/22.96b59303.png";